import { render, staticRenderFns } from "./NginxMonitor.vue?vue&type=template&id=4878dc7d&"
import script from "./NginxMonitor.vue?vue&type=script&lang=js&"
export * from "./NginxMonitor.vue?vue&type=script&lang=js&"
import style0 from "./NginxMonitor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports